<div  *ngIf="!noData" class="matched" [ngClass]="{'alignedForLess100' : alignPercentage, 'alignedFor100' : !alignPercentage}" [innerHTML]="matchedPercentage"></div>
<div class="widget-title">Grade Match/Num Graded Vehicles</div>
<div class="gradeMatchContainer">
    <div [hidden]="noData" [ngClass]="noData ? 'col-1': 'col-8'">
        <canvas id="gradeMatch" >
        </canvas>
    </div>
    <div *ngIf="!noData" [innerHTML]="html" class="percentage"></div>
    <div *ngIf="noData" class="noData">No Data Available</div>
</div>
